import {
  actingUserAppSelectors,
  impersonateGuide,
} from 'redux/slices/actingUserSlice';
import { useAppDispatch } from 'redux/store-hooks';
import Table, { TableColumnConfig, TableConfig } from 'toolkit/table/table';
import { stringComparer } from 'utilities/comparer';
import { Button } from '@act/storybook';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import { Permission } from '@act/shared/authorization';

export type GuideTableData = {
  guideId: string;
  guideName: string;
  location: string;
};

const GuideTable = (props: {
  guideData: GuideTableData[];
  onRowClick?: (row: GuideTableData) => unknown;
}) => {
  const dispatch = useAppDispatch();
  const handleImpersonate = (guideId: string) => {
    // Impersonate the selected guide
    dispatch(impersonateGuide(guideId));
  };
  const canImpersonate = actingUserAppSelectors.useUserHasPermission(
    Permission.CAN_IMPERSONATE_USERS
  );

  const tableColumnConfig: TableColumnConfig<GuideTableData> = [
    {
      title: 'Guide',
      mapper: (data: GuideTableData) => {
        return (
          <>
            {data.guideName}
            {canImpersonate && (
              <Button
                onClick={() => handleImpersonate(data.guideId)}
                startIcon={<AccountBoxIcon />}
                debounced
                sx={{
                  float: 'right',
                }}
              >
                Impersonate
              </Button>
            )}
          </>
        );
      },
      descSortFunc: (a, b) =>
        stringComparer(a.guideName.toLowerCase(), b.guideName.toLowerCase()),
    },
    {
      title: 'Location',
      mapper: (data: GuideTableData) => {
        return <>{data.location}</>;
      },
    },
  ];

  const tableConfig: TableConfig<GuideTableData> = {
    rowIdentifier: 'guideId',
    columns: tableColumnConfig,
    onRowClick: props.onRowClick,
  };
  return <Table data={props.guideData} config={tableConfig} />;
};

export default GuideTable;
